import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter, connectRouter, routerMiddleware } from 'connected-react-router';
import { Route, Switch } from 'react-router';
import * as ReactGA from 'react-ga';

import allReducers from './reducers';

import './styles/style.css';

// Pages
import WelcomePage from './pages/welcome-page';
import AnimationPage from './pages/animation-page';
import BacteriaPage from './pages/bacteria-page';
import HelpPage from './pages/help';
import AnimationNew from "./components/animation-new";

class App extends Component {

    constructor(props) {
        super(props);

        this.history = createBrowserHistory();
        this.store = createStore(
            connectRouter(this.history)(allReducers),
            {},
            compose(
                applyMiddleware(
                    routerMiddleware(this.history)
                )
            )
        );

        ReactGA.initialize( 'UA-28388718-5', { debug: false } );
    }

    render() {
        return (
            <Provider store={ this.store }>
                <ConnectedRouter history={ this.history }>
                    <Switch>
                        <Route exact path={ process.env.PUBLIC_URL + "/" } component={ WelcomePage } />
                        <Route path={ process.env.PUBLIC_URL + "/choose-a-bacteria" } component={ AnimationPage } />
                        <Route path={ process.env.PUBLIC_URL + "/bacteria/:name" } component={ BacteriaPage } />
                    </Switch>
                </ConnectedRouter>
            </Provider>
        );
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js